export default __webpack_public_path__ + "static/media/keto_meal_times@3x.51436c14.jpg";